import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { Row } from "reactstrap";

import { staticPages } from "../../context/pageTree";
import { useAppData } from "../../context/data";

import tuttiLogo from "../../media/images/dugnad.png";
import tuttiLogoDark from "../../media/images/dugnadDarkMode.png";
import { getFooterInformation } from "./getFooterInformation";

export default function Footer() {
  const location = useLocation();
  const { appData } = useAppData();

  const [showSeller, setShowSeller] = useState(false);
  const [footerInfo, setFooterInfo] = useState<any>(null);
  const [isDarkMode, setIsDarkMode] = useState(false);

  const campaign = appData?.campaign;
  const campaignTypeId = campaign?.campaign_type;
  const tags = campaign?.tags;

  useEffect(() => {
    if (location.pathname === "/checkout") return;
    setShowSeller(!staticPages.find((p) => p.link === location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    if (!campaignTypeId) return void setFooterInfo(null);
    getFooterInformation(campaignTypeId, tags)
      .then(setFooterInfo)
      .catch(() => setFooterInfo(null));
  }, [campaignTypeId, JSON.stringify(tags)]);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function" ||
      typeof navigator === "undefined"
    )
      return;

    const isAndroid = /Android/i.test(navigator.userAgent);
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const updateMode = () => setIsDarkMode(isAndroid && mediaQuery.matches);

    updateMode();
    mediaQuery.addEventListener("change", updateMode);
    return () => mediaQuery.removeEventListener("change", updateMode);
  }, []);

  const footerMain = footerInfo?.main;
  const footerText = footerInfo?.info;
  const footerOrg = footerInfo?.org_nr;
  const agreementUrl = footerInfo?.agreement_url;
  const footerLogo = isDarkMode ? tuttiLogoDark : tuttiLogo;

  return (
    <>
      <footer className={"footer"}>
        <div className={`footer-top`}>
          <img
            className={"footer-logo"}
            src={footerLogo}
            alt="Tuttilodd logo"
          />

          <p>
            <span className={"br"}>
              {footerMain ? (
                footerMain
              ) : (
                <>
                  Dugnad.org en tjeneste levert av{" "}
                  <a href="https://www.styreportalen.no">Styreportalen AS</a>
                </>
              )}
            </span>

            <span className={"br footer-info"}>
              {footerText ??
                "Styreportalen AS - Edvard Griegs vei 3B 5059 Bergen\nOrganisasjonsnummer 917273898"}
            </span>
          </p>
        </div>

        <div className={`footer-bottom`}>
          <Row className={"footer-links"}>
            <Link to={"/about"}>Om Innsamling</Link>
          </Row>

          <Row className={"footer-agreements"} sm={6}>
            {agreementUrl ? (
              <a href={agreementUrl} target="_blank" rel="noopener noreferrer">
                Kjøpsvilkår & Personvernerklæring
              </a>
            ) : (
              <Link to={"/404"}>Kjøpsvilkår & Personvernerklæring</Link>
            )}
          </Row>
        </div>
      </footer>
    </>
  );
}
